import { collection, doc, setDoc } from "firebase/firestore";
import { db } from "../config/firebase";
import { InstantCallRequest } from "../../types/InstantCall";

class InstantCallService {
  /**
   * Adds a new instant call request to the 'instantCallRequests' collection.
   * @param {InstantCallRequest} request - The structured call request object.
   * @returns {Promise<string>} The ID of the new request document.
   */
  async addInstantCallRequest(request) {
    try {
      // Create a unique ID if one is not provided
      const newId = request.id || doc(collection(db, "instantCallRequests")).id;
      const requestRef = doc(db, "instantCallRequests", newId);

      // Prepare data for Firestore
      const requestData = request.toJson
        ? request.toJson()
        : {
            ...request,
            id: newId,
            requestedAt: new Date().toISOString(),
            status: "new",
          };

      await setDoc(requestRef, requestData);
      return newId; // Return the ID of the new document
    } catch (error) {
      console.error("Error adding instant call request:", error);
      throw new Error("Instant call request submission failed.");
    }
  }

  // Future methods could include: getRequests, updateRequestStatus, etc.
}

export const instantCallService = new InstantCallService();
export default InstantCallService;
